let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4rk4Z")).then(() => parcelRequire('5zJw9'));